module.exports = __webpack_public_path__ + "assets/img/1_691_big.355a2b84.jpg";